<template>
  <div class="q-single-product">
    <a :href="url" class="q-custom-link">{{ label }}</a>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
defineProps(['url', 'label']);
</script>

<style scoped>
.q-single-product {
  display: flex;
  align-items: center;
  padding: 8px;
  margin: 10px auto;
  max-width: 60%;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  position:relative;
}

.q-single-product:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.q-custom-link {
  color: var(--q-secondary-color, #007bff);
  text-decoration: none;
  font-weight: 500;
  font-size: 1em;
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding-left: 28px;
  transition: color 0.2s ease;
}

.q-custom-link:hover {
  color: var(--q-primary-color, #0056b3);
  text-decoration: none;
}

.q-custom-link::before {
  content: '';
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  background-color: var(--q-secondary-color, #007bff);
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7zm-2 16H5V5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7z'/%3E%3C/svg%3E");
  -webkit-mask-size: contain;
  -webkit-mask-repeat: no-repeat;
}

.q-custom-link:hover::before {
  background-color: var(--q-primary-color, #0056b3);
}
</style>